export default theme => ({
    root: {
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
    },
    header: {
        padding: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    backButton: {
        marginRight: theme.spacing(1)
    },
    headerTitle: {
        lineHeight: 1.2
    },
    listContainer: {
        padding: theme.spacing(2),
        flexGrow: 1
    },
    cardActionArea: {
        width: '100%',
        display: 'block',
        textAlign: 'left',
        padding: 0
    },
    avatar: {
        color: '#fff',
        width: 32,
        height: 32,
        fontSize: '0.9rem',
        fontWeight: 'bold'
    },
    contentContainer: {
        flexGrow: 1
    },
    metaDataBox: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.secondary
    },
    boxIcon: {
        fontSize: 18,
        marginRight: 6
    },
    boxAmountText: {
        fontWeight: 500
    },
    nextIconContainer: {
        marginLeft: theme.spacing(1),
        display: 'flex',
        alignItems: 'center'
    }
});